<template>
  <v-card id="account-setting-card">
    <v-card-title class="justify-center">
      <span class="text-h5"><strong>ADVERSE REACTION REPORT</strong></span>
    </v-card-title>
    <!-- tabs -->
    <!-- <v-tabs
      v-model="tab"
      show-arrows
    >
      <v-tab
        v-for="tab in tabs"
        :key="tab.icon"
      >
        <v-icon
          size="20"
          class="me-3"
        >
          {{ tab.icon }}
        </v-icon>
        <span>{{ tab.title }}</span>
      </v-tab>
    </v-tabs> -->
     <v-tabs v-model="active_tab">
      <v-tab
        key="0"
        :disabled="readOnlyField === true"
      >
        <span>OS (oculus sinister)</span>
      </v-tab>
      <v-tab
        key="1"
        :disabled="readOnlyField1 === true"
      >
        
        <span>OD (oculus dextrus)</span>
      </v-tab>
      </v-tabs>

    <!-- tabs item -->
    <v-tabs-items v-model="active_tab">
      <v-tab-item key="0">
        <AdverseReactionOS/>
      </v-tab-item>

      <v-tab-item key="1">
        <AdverseReactionOD />
        
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import { ref } from '@vue/composition-api'

// demos
import adversesevice from '@/service/AdverseReactionForm.service'
import AdverseReactionOS from "./AdverseReactionOS.vue"
import AdverseReactionOD from "./AdverseReactionOD.vue"

export default {
  components: {
    AdverseReactionOS,
    AdverseReactionOD,
  },
  setup() {
    // const tab = ref('')

   
    // const tabs = [
    //   { title: 'Adverse Reaction OS(Left Eye)'},
    //    { title: 'Adverse Reaction OD(Right Eye)'},
       
      
    // ]
  
   return {
      // tab: "tab2",
      readOnlyField: false,
      readOnlyField1: false,
      active_tab: 0,
    }
  },
  watch: {
    options: {
      handler() {
        // this.AdverseList()
      },
      deep: true,
    },
  },

  async mounted() {
    this.AdverseList()
  },

  methods:{
      async AdverseList() {
      const urlData = this.$route.params.donor_id
      // const donorId = urlData.split('&')[0]
      const tissueId = urlData.split('&')[1];

      if(tissueId == 'EBSR-23-01121-OS' || tissueId == "EBSR-23-01121-OD" || tissueId == "EBSR-23-01126-OD"){
        location.href = "https://app.ebsr.in/Donor/AdverseReactionForm/" + this.$route.params.donor_id;
        return
      }
      // const service = new adversesevice()
      // let response = await service.AdverseReaction_OD(DonorId) 
      if(tissueId.includes('OS')){
        this.readOnlyField1 = true
        this.active_tab = "0"
      }
      if(tissueId.includes('OD')){
        this.readOnlyField = true
        this.active_tab = "1"
      }
      // if(response.os_id == null && response.od_id == null){
      //   //console.log("bhati new")
      //   this.readOnlyField = true
      //   this.readOnlyField1 = true
      //   this.active_tab = "2"
      // }
  }
}
}

</script>

	

